<template>
  <dr-simple-layout @modelChanged="onModelChanged" :model="innerValue"/>
</template>

<script>
export default {
  inject: ['stateName'],
  props: ['layout'],
  data: () => ({
    innerValue: undefined
  }) ,
  created() {
    this.innerValue = this.layout

    // регистрация служебного модуля vuex для этого проигрывателя
    this.$store.registerModule(this.stateName, {
      namespaced: true,
      state: {
        isEditorMode: this.editorMode,
        selectedWidget: undefined
      },
      mutations: {
        setSelectedWidget(state, widget) {
          state.selectedWidget = widget
        },
        setSelectedWidgetProperties(state, widgetProps) {
          for (let prop in widgetProps) {
            state.selectedWidget[prop] = widgetProps[prop]
          }
        }
      }
    })
  },
  methods: {
    onModelChanged() {
      this.$emit('input',  this.innerValue)
    }
  }
}
</script>

<style>

</style>
